type ColorMap = Record<
  string,
  {
    bg: string;
    text: string;
    border: string;
  }
>;

export const colorMap: ColorMap = {
  orange: {
    bg: "bg-orange-50 dark:bg-orange-100",
    text: "text-orange-700 dark:text-orange-800",
    border: "border-orange-200 dark:border-orange-300",
  },
  amber: {
    bg: "bg-amber-50 dark:bg-amber-100",
    text: "text-amber-700 dark:text-amber-800",
    border: "border-amber-200 dark:border-amber-300",
  },
  yellow: {
    bg: "bg-yellow-50 dark:bg-yellow-100",
    text: "text-yellow-700 dark:text-yellow-800",
    border: "border-yellow-200 dark:border-yellow-300",
  },
  lime: {
    bg: "bg-lime-50 dark:bg-lime-100",
    text: "text-lime-700 dark:text-lime-800",
    border: "border-lime-200 dark:border-lime-300",
  },
  green: {
    bg: "bg-green-50 dark:bg-green-100",
    text: "text-green-700 dark:text-green-800",
    border: "border-green-200 dark:border-green-300",
  },
  emerald: {
    bg: "bg-emerald-50 dark:bg-emerald-100",
    text: "text-emerald-700 dark:text-emerald-800",
    border: "border-emerald-200 dark:border-emerald-300",
  },
  teal: {
    bg: "bg-teal-50 dark:bg-teal-100",
    text: "text-teal-700 dark:text-teal-800",
    border: "border-teal-200 dark:border-teal-300",
  },
  cyan: {
    bg: "bg-cyan-50 dark:bg-cyan-100",
    text: "text-cyan-700 dark:text-cyan-800",
    border: "border-cyan-200 dark:border-cyan-300",
  },
  sky: {
    bg: "bg-sky-50 dark:bg-sky-100",
    text: "text-sky-700 dark:text-sky-800",
    border: "border-sky-200 dark:border-sky-300",
  },
  blue: {
    bg: "bg-blue-50 dark:bg-blue-100",
    text: "text-blue-700 dark:text-blue-800",
    border: "border-blue-200 dark:border-blue-300",
  },
  fuchsia: {
    bg: "bg-fuchsia-50 dark:bg-fuchsia-100",
    text: "text-fuchsia-700 dark:text-fuchsia-800",
    border: "border-fuchsia-200 dark:border-fuchsia-300",
  },
  pink: {
    bg: "bg-pink-50 dark:bg-pink-100",
    text: "text-pink-700 dark:text-pink-800",
    border: "border-pink-200 dark:border-pink-300",
  },
};

const allowedColors = Object.keys(colorMap);

const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

const sanitize = (str: string) => str.trim().toLowerCase();

export const getInterestColor = (interest: string) => {
  const sanitized = sanitize(interest);
  const index = hashString(sanitized) % allowedColors.length;
  const color = allowedColors[index];

  return colorMap[color];
};
